import React, { FC, useState, useContext } from "react";
import { DayPickerRangeController } from "react-dates";
import { FiltersContext } from "../context/FiltersProvider";
import { FilterType } from "../types";

const initialDateRange = { startDate: null, endDate: null };

const DateRangeFilter: FC = () => {
  const { actions } = useContext(FiltersContext);
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [focusedInput, setFocusedInput] = useState("startDate");
  const [isOpened, setIsOpened] = useState(false);
  const handleDateChanged = (date): void => {
    setDateRange({ ...date });
    if (date.startDate && date.endDate) {
      actions.onSelect(FilterType.DATE_RANGE, date);
    }
  };
  const handleFocusChanged = (focus): void => {
    if (!focus) {
      setFocusedInput("startDate");
      setIsOpened(false);
      return setDateRange(initialDateRange);
    }
    setFocusedInput(focus);
  };
  const handleToggled = (): void => {
    setIsOpened((prev) => !prev);
    setDateRange(initialDateRange);
  };
  return (
    <div className="filter">
      <button
        className="dropdown-toggle filter-toggle"
        aria-expanded={isOpened}
        onClick={handleToggled}
      >
        Date Range
      </button>
      {isOpened && (
        <DayPickerRangeController
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          onDatesChange={handleDateChanged}
          focusedInput={focusedInput}
          onFocusChange={handleFocusChanged}
          onOutsideClick={handleToggled}
          keepOpenOnDateSelect={false}
        />
      )}
    </div>
  );
};

export default DateRangeFilter;
